import { useSelector } from "react-redux";
import { useAppDispatch } from "hooks/hooks";
import Modal from "components/Modal/Modal";
import {
  deletePayroll,
  deletePayrollForPrint,
  selectPayrollForDeletion,
  selectState,
  setDeletePayrollModalOpen,
} from "../payroll.slice";
import { selectEmployee } from "../../employee/employeeSlice";
import { monthNames } from "utils/translationDictionary";
import { toast } from "react-toastify";

const DeletePayrollModal = () => {
  const { deletePayrollModalOpen } = useSelector(selectState);
  const payroll = useSelector(selectPayrollForDeletion);
  const employee = useSelector(selectEmployee);
  const dispatch = useAppDispatch();

  const close = () => {
    dispatch(setDeletePayrollModalOpen({ visible: false, index: -1 }));
  };

  const doDelete = async () => {
    try {
      await dispatch(deletePayroll({
        employeeId: employee.employeeId,
        payrollId: payroll.payrollId,
      })).unwrap();

      dispatch(deletePayrollForPrint({
        year: payroll.year,
        month: payroll.month
      }));

      toast.success("Obračun je uspešno obrisan.");
      close();
    } catch (err) {
      console.log(err);
      toast.error("Greška pri brisanju obračuna.");
    }
  };

  return (
    <Modal
      onClick={doDelete}
      isOpen={deletePayrollModalOpen}
      onClose={close}
      title="Brisanje obračuna"
    >
      <p className="info-msg">
        Da li ste sigurni da želite da obrišete sledeći obračun:
        <br />
        <br />
        <b>
          {payroll && monthNames[payroll.month - 1]} {payroll?.year} ?
        </b>
      </p>
    </Modal>
  );
};

export default DeletePayrollModal;
